module.exports = __webpack_public_path__ + "static/logo-1d98694d0e29350552d0d8e520f75b1c.png";